import { render } from "./DashboardNotifications.vue?vue&type=template&id=80dfdaf4&scoped=true&lang=pug"
import script from "./DashboardNotifications.vue?vue&type=script&lang=js"
export * from "./DashboardNotifications.vue?vue&type=script&lang=js"

import "./DashboardNotifications.vue?vue&type=style&index=0&id=80dfdaf4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80dfdaf4"]])

export default __exports__